import React from 'react';
import { linkResolver } from '@utils/prismic';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { IMenuAccount } from '@monofront/types';
import { LABEL_1STLEVEL } from '@monofront/business/constants';
import { IShopAccountBody } from '@monofront/types';

const buildMenu = (menu: IShopAccountBody[]) => {
  const formattedMenu = menu.filter(
    (item) =>
      item.slice_type === LABEL_1STLEVEL &&
      item.primary.desktop &&
      item.primary.sidemenudesktop,
  );

  return formattedMenu;
};

const DesktopSideMenu: React.FC<IMenuAccount> = ({ menuAccount }) => {
  const router = useRouter();

  if (!menuAccount) {
    return null;
  }

  return (
    <>
      <div className="container">
        {buildMenu(menuAccount)?.map((item) => {
          const url = linkResolver(item.primary.nav_link);
          const isCurrentUrl = url === router.pathname.replace('/[id]', '');

          return item.primary.desktop ? (
            <Link key={item.primary.nav_link.id} href={url} legacyBehavior>
              <a
                data-testid={`DesktopSideMenu-go-to-${item.primary.link_text}`}
              >
                <div className="item">
                  <div className={`${isCurrentUrl ? `active` : ''}`} />
                  <span>{item.primary.link_text}</span>
                </div>
              </a>
            </Link>
          ) : null;
        })}
      </div>
      <style jsx>{`
        .container {
          border-radius: var(--rd-1);
          background: var(--white);
        }

        .item {
          position: relative;
          display: flex;
          flex-direction: row;
          cursor: pointer;
          transition: all 0.3s ease-out 0s;
          padding: var(--space-5) var(--space-3);
          border-bottom: var(--border);
        }

        .item > span {
          margin-left: var(--space-3);
        }

        .active:after {
          width: 8px;
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          background: var(--clr-primary-1);
          height: 100%;
          border-radius: var(--rd-2);
        }

        .item:hover {
          background-color: var(--clr-primary-5);
        }
      `}</style>
    </>
  );
};

export default DesktopSideMenu;
